export default {
  from: {
    new: 'Novo',
    'delivery-from': 'Entrega de',
  },
  to: {
    delivered: 'Entregue a',
    deliver: 'Entregar para',
  },
  comment: 'Comentário do motorista',
}
